<template>
  <app-toast class='delete-bank-toast' :message='message'>
    <div class='toast-body' v-html='$t("accounts.delete", {bankName: message.bank.name})'>
    </div>
  </app-toast>
</template>

<script>
  import appToast from '@/components/app-toast'

  export default {
    name: 'delete-bank',
    props: {
      message: Object
    },

    components: {
      'app-toast': appToast
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .delete-bank-toast {
    strong {
      color: map_get($palette-primary, main);
    }
  }
</style>
